/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	CreateThirdPartyDevice400,
	CreateThirdPartyDevice401,
	CreateThirdPartyDevice403,
	CreateThirdPartyDevice409,
	CreateThirdPartyDevice500,
	DeleteThirdPartyDevice400,
	DeleteThirdPartyDevice404,
	DeleteThirdPartyDevice500,
	GetThirdPartyDevice400,
	GetThirdPartyDevice404,
	GetThirdPartyDevice500,
	ListThirdPartyDevices400,
	ListThirdPartyDevices500,
	ThirdPartyDevice,
	ThirdPartyDeviceCreate,
	ThirdPartyDeviceUpdate,
	UpdateThirdPartyDevice400,
	UpdateThirdPartyDevice404,
	UpdateThirdPartyDevice500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListThirdPartyDevicesUrl = () => {
	return `/third-party-devices`;
};

/**
 * @summary List all third-party devices owned by the authenticated user
 */
export const listThirdPartyDevices = async (
	options?: RequestInit,
): Promise<ThirdPartyDevice[]> => {
	return customFetch<ThirdPartyDevice[]>(getListThirdPartyDevicesUrl(), {
		...options,
		method: "GET",
	});
};

export const getListThirdPartyDevicesQueryKey = () => {
	return ["third-party-devices"] as const;
};

export const getListThirdPartyDevicesQueryOptions = <
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof listThirdPartyDevices>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListThirdPartyDevicesQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listThirdPartyDevices>>
	> = ({ signal }) => listThirdPartyDevices({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listThirdPartyDevices>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThirdPartyDevicesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listThirdPartyDevices>>
>;
export type ListThirdPartyDevicesQueryError =
	| ListThirdPartyDevices400
	| ListThirdPartyDevices500;

export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listThirdPartyDevices>>,
					TError,
					Awaited<ReturnType<typeof listThirdPartyDevices>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listThirdPartyDevices>>,
					TError,
					Awaited<ReturnType<typeof listThirdPartyDevices>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all third-party devices owned by the authenticated user
 */

export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListThirdPartyDevicesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all third-party devices owned by the authenticated user
 */
export const useSetListThirdPartyDevicesQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof listThirdPartyDevices>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listThirdPartyDevices>> | undefined,
			  ) => Awaited<ReturnType<typeof listThirdPartyDevices>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listThirdPartyDevices>>
		>({ queryKey: getListThirdPartyDevicesQueryKey() }, updater);
	};
};

/**
 * @summary List all third-party devices owned by the authenticated user
 */
export const useGetListThirdPartyDevicesQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listThirdPartyDevices>>>(
			getListThirdPartyDevicesQueryKey(),
		);
};

export const getCreateThirdPartyDeviceUrl = () => {
	return `/third-party-devices`;
};

/**
 * @summary Register a new third-party device
 */
export const createThirdPartyDevice = async (
	thirdPartyDeviceCreate: ThirdPartyDeviceCreate,
	options?: RequestInit,
): Promise<ThirdPartyDevice> => {
	return customFetch<ThirdPartyDevice>(getCreateThirdPartyDeviceUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(thirdPartyDeviceCreate),
	});
};

export const getCreateThirdPartyDeviceMutationOptions = <
	TError =
		| CreateThirdPartyDevice400
		| CreateThirdPartyDevice401
		| CreateThirdPartyDevice403
		| CreateThirdPartyDevice409
		| CreateThirdPartyDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createThirdPartyDevice>>,
		TError,
		{ data: ThirdPartyDeviceCreate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createThirdPartyDevice>>,
	TError,
	{ data: ThirdPartyDeviceCreate },
	TContext
> => {
	const mutationKey = ["createThirdPartyDevice"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createThirdPartyDevice>>,
		{ data: ThirdPartyDeviceCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createThirdPartyDevice(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateThirdPartyDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof createThirdPartyDevice>>
>;
export type CreateThirdPartyDeviceMutationBody = ThirdPartyDeviceCreate;
export type CreateThirdPartyDeviceMutationError =
	| CreateThirdPartyDevice400
	| CreateThirdPartyDevice401
	| CreateThirdPartyDevice403
	| CreateThirdPartyDevice409
	| CreateThirdPartyDevice500;

/**
 * @summary Register a new third-party device
 */
export const useCreateThirdPartyDevice = <
	TError =
		| CreateThirdPartyDevice400
		| CreateThirdPartyDevice401
		| CreateThirdPartyDevice403
		| CreateThirdPartyDevice409
		| CreateThirdPartyDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createThirdPartyDevice>>,
			TError,
			{ data: ThirdPartyDeviceCreate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createThirdPartyDevice>>,
	TError,
	{ data: ThirdPartyDeviceCreate },
	TContext
> => {
	return useMutation(
		getCreateThirdPartyDeviceMutationOptions(options),
		queryClient,
	);
};
export const getGetThirdPartyDeviceUrl = (thirdPartyDeviceId: string) => {
	return `/third-party-devices/${thirdPartyDeviceId}`;
};

/**
 * @summary Get a single third-party device by ID
 */
export const getThirdPartyDevice = async (
	thirdPartyDeviceId: string,
	options?: RequestInit,
): Promise<ThirdPartyDevice> => {
	return customFetch<ThirdPartyDevice>(
		getGetThirdPartyDeviceUrl(thirdPartyDeviceId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetThirdPartyDeviceQueryKey = (thirdPartyDeviceId: string) => {
	return ["third-party-devices", thirdPartyDeviceId] as const;
};

export const getGetThirdPartyDeviceQueryOptions = <
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetThirdPartyDeviceQueryKey(thirdPartyDeviceId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getThirdPartyDevice>>
	> = ({ signal }) =>
		getThirdPartyDevice(thirdPartyDeviceId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: thirdPartyDeviceId !== null && thirdPartyDeviceId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getThirdPartyDevice>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetThirdPartyDeviceQueryResult = NonNullable<
	Awaited<ReturnType<typeof getThirdPartyDevice>>
>;
export type GetThirdPartyDeviceQueryError =
	| GetThirdPartyDevice400
	| GetThirdPartyDevice404
	| GetThirdPartyDevice500;

export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getThirdPartyDevice>>,
					TError,
					Awaited<ReturnType<typeof getThirdPartyDevice>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getThirdPartyDevice>>,
					TError,
					Awaited<ReturnType<typeof getThirdPartyDevice>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single third-party device by ID
 */

export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetThirdPartyDeviceQueryOptions(
		thirdPartyDeviceId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single third-party device by ID
 */
export const useSetGetThirdPartyDeviceQueryData = () => {
	const queryClient = useQueryClient();
	return (
		thirdPartyDeviceId: string,
		updater:
			| Awaited<ReturnType<typeof getThirdPartyDevice>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getThirdPartyDevice>> | undefined,
			  ) => Awaited<ReturnType<typeof getThirdPartyDevice>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getThirdPartyDevice>>>(
			{ queryKey: getGetThirdPartyDeviceQueryKey(thirdPartyDeviceId) },
			updater,
		);
	};
};

/**
 * @summary Get a single third-party device by ID
 */
export const useGetGetThirdPartyDeviceQueryData = () => {
	const queryClient = useQueryClient();
	return (thirdPartyDeviceId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getThirdPartyDevice>>>(
			getGetThirdPartyDeviceQueryKey(thirdPartyDeviceId),
		);
};

export const getUpdateThirdPartyDeviceUrl = (thirdPartyDeviceId: string) => {
	return `/third-party-devices/${thirdPartyDeviceId}`;
};

/**
 * @summary Update an existing third-party device
 */
export const updateThirdPartyDevice = async (
	thirdPartyDeviceId: string,
	thirdPartyDeviceUpdate: ThirdPartyDeviceUpdate,
	options?: RequestInit,
): Promise<ThirdPartyDevice> => {
	return customFetch<ThirdPartyDevice>(
		getUpdateThirdPartyDeviceUrl(thirdPartyDeviceId),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(thirdPartyDeviceUpdate),
		},
	);
};

export const getUpdateThirdPartyDeviceMutationOptions = <
	TError =
		| UpdateThirdPartyDevice400
		| UpdateThirdPartyDevice404
		| UpdateThirdPartyDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateThirdPartyDevice>>,
		TError,
		{ thirdPartyDeviceId: string; data: ThirdPartyDeviceUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateThirdPartyDevice>>,
	TError,
	{ thirdPartyDeviceId: string; data: ThirdPartyDeviceUpdate },
	TContext
> => {
	const mutationKey = ["updateThirdPartyDevice"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateThirdPartyDevice>>,
		{ thirdPartyDeviceId: string; data: ThirdPartyDeviceUpdate }
	> = (props) => {
		const { thirdPartyDeviceId, data } = props ?? {};

		return updateThirdPartyDevice(thirdPartyDeviceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateThirdPartyDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateThirdPartyDevice>>
>;
export type UpdateThirdPartyDeviceMutationBody = ThirdPartyDeviceUpdate;
export type UpdateThirdPartyDeviceMutationError =
	| UpdateThirdPartyDevice400
	| UpdateThirdPartyDevice404
	| UpdateThirdPartyDevice500;

/**
 * @summary Update an existing third-party device
 */
export const useUpdateThirdPartyDevice = <
	TError =
		| UpdateThirdPartyDevice400
		| UpdateThirdPartyDevice404
		| UpdateThirdPartyDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateThirdPartyDevice>>,
			TError,
			{ thirdPartyDeviceId: string; data: ThirdPartyDeviceUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateThirdPartyDevice>>,
	TError,
	{ thirdPartyDeviceId: string; data: ThirdPartyDeviceUpdate },
	TContext
> => {
	return useMutation(
		getUpdateThirdPartyDeviceMutationOptions(options),
		queryClient,
	);
};
export const getDeleteThirdPartyDeviceUrl = (thirdPartyDeviceId: string) => {
	return `/third-party-devices/${thirdPartyDeviceId}`;
};

/**
 * @summary Delete a third-party device
 */
export const deleteThirdPartyDevice = async (
	thirdPartyDeviceId: string,
	options?: RequestInit,
): Promise<ThirdPartyDevice> => {
	return customFetch<ThirdPartyDevice>(
		getDeleteThirdPartyDeviceUrl(thirdPartyDeviceId),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteThirdPartyDeviceMutationOptions = <
	TError =
		| DeleteThirdPartyDevice400
		| DeleteThirdPartyDevice404
		| DeleteThirdPartyDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
		TError,
		{ thirdPartyDeviceId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
	TError,
	{ thirdPartyDeviceId: string },
	TContext
> => {
	const mutationKey = ["deleteThirdPartyDevice"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
		{ thirdPartyDeviceId: string }
	> = (props) => {
		const { thirdPartyDeviceId } = props ?? {};

		return deleteThirdPartyDevice(thirdPartyDeviceId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteThirdPartyDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteThirdPartyDevice>>
>;

export type DeleteThirdPartyDeviceMutationError =
	| DeleteThirdPartyDevice400
	| DeleteThirdPartyDevice404
	| DeleteThirdPartyDevice500;

/**
 * @summary Delete a third-party device
 */
export const useDeleteThirdPartyDevice = <
	TError =
		| DeleteThirdPartyDevice400
		| DeleteThirdPartyDevice404
		| DeleteThirdPartyDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
			TError,
			{ thirdPartyDeviceId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
	TError,
	{ thirdPartyDeviceId: string },
	TContext
> => {
	return useMutation(
		getDeleteThirdPartyDeviceMutationOptions(options),
		queryClient,
	);
};
